/**
 * Piltast-navigasjon i lister med uthevet element (mentions, søketreff,
 * fanelinjer). Ren funksjon så komponentene deler samme regler (VIB-2541).
 */
export type ListNavKey = "ArrowDown" | "ArrowUp" | "Home" | "End";

export function isListNavKey(key: string): key is ListNavKey {
  return key === "ArrowDown" || key === "ArrowUp" || key === "Home" || key === "End";
}

/** Neste uthevede indeks. Piler wrapper rundt; tom liste gir -1. */
export function moveHighlight(current: number, key: ListNavKey, length: number): number {
  if (length <= 0) return -1;
  const safe = Math.min(Math.max(current, 0), length - 1);
  switch (key) {
    case "ArrowDown":
      return (safe + 1) % length;
    case "ArrowUp":
      return (safe - 1 + length) % length;
    case "Home":
      return 0;
    case "End":
      return length - 1;
  }
}
